import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useRef } from "react";
import Login from "./components/login";
import Navigation from "./components/Navigation";
import ContinueAssessment from "./components/continue";
import Remainders from "./components/remainder";
import Summaries from "./components/summaries";
import Header from "./components/Header";
import GoalsPage from "./components/GoalsPage";
import Editgoal from "./components/Editgoal";
import Startassessment from "./components/start-assessment";
import Help from "./components/help";
import Summarypage from "./components/summarypage";
import FeedbackPage from "./components/FeedbackPage";
import UpdateGoal from "./components/UpdateGoal";
import DemographicsData from "./components/DemographicsData";
import BackgroundInfoData from "./components/BackgroundInfoData";
import GuideLibrary from "./components/GuideLibrary";
import ReminderPopup from "./components/ReminderPopup";


import "./App.css";
import Footer from "./components/footer";
import Interventionspage from "./components/Interventions";
import GoalsetDownloadpage from "./components/goalsetdownload";
import GoalReviewpage from "./components/goalreview";

import ReviewStartassessment from "./components/Review-assessment";
import HistoricalPathway from "./components/HistoricalPathway";
import ClientHistory from "./components/ClientHistory";
import ProtectedRoute from "./components/ProtectedRoute";
import URLLockGuard from "./components/URLLockGuard";

function AppContent() {
  const mainContentRef = useRef(null);
  const location = useLocation();
  const isLoginPage = location.pathname === "/";

  const handleSkip = (e) => {
    e.preventDefault();
    const firstCard = document.querySelector(".feature-card-link");
    if (firstCard) {
      firstCard.focus();
      firstCard.scrollIntoView();
    } else if (mainContentRef.current) {
      mainContentRef.current.focus();
    }
  };

  return (
    <div className="app-container">

      {/* Skip Navigation Link - WCAG SC 2.4.1 */}
      <a href="#main-content" className="skip-link" onClick={handleSkip}>
        Skip to main content
      </a>

      <div className="main-content" id="main-content" role="main" ref={mainContentRef} tabIndex={-1}>
        <URLLockGuard>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/Home" element={<ProtectedRoute><><Header /><Navigation /></></ProtectedRoute>} />
          <Route path="/start-assessment" element={<ProtectedRoute><><Header /><Startassessment /></></ProtectedRoute>} />
          <Route path="/review-assessment" element={<ProtectedRoute><><Header /><ReviewStartassessment /></></ProtectedRoute>} />
          <Route path="/continue-assessment" element={<ProtectedRoute><><Header /><ContinueAssessment /></></ProtectedRoute>} />
          <Route path="/Suggested-interventions" element={<ProtectedRoute><><Header /><Summaries /></></ProtectedRoute>} />
          <Route path="/Goals" element={<ProtectedRoute><><Header /><GoalsPage /></></ProtectedRoute>} />
          <Route path="/Reminder" element={<ProtectedRoute><><Header /><Remainders /></></ProtectedRoute>} />
          <Route path="/Editgoal" element={<ProtectedRoute><><Header /><Editgoal /></></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute><><Header /><Help /></></ProtectedRoute>} />
          <Route path="/Library" element={<ProtectedRoute><><Header /><GuideLibrary /></></ProtectedRoute>} />
          <Route path="/summarypage" element={<ProtectedRoute><><Header /><Summarypage /></></ProtectedRoute>} />
          <Route path="/Interventions" element={<ProtectedRoute><><Header /><Interventionspage /></></ProtectedRoute>} />
          <Route path="/FeedbackPage" element={<ProtectedRoute><><Header /><FeedbackPage /></></ProtectedRoute>} />
          <Route path="/updategoal" element={<ProtectedRoute><><Header /><UpdateGoal /></></ProtectedRoute>} />
          <Route path="/goalsetdownload" element={<ProtectedRoute><><Header /><GoalsetDownloadpage /></></ProtectedRoute>} />
          <Route path="/goalreview" element={<ProtectedRoute><><Header /><GoalReviewpage /></></ProtectedRoute>} />
          <Route path="/goalreview-history" element={<ProtectedRoute><><Header /><GoalReviewpage /></></ProtectedRoute>} />
          <Route path="/demographics-data" element={<ProtectedRoute><><Header /><DemographicsData /></></ProtectedRoute>} />
          <Route path="/background-info-data" element={<ProtectedRoute><><Header /><BackgroundInfoData /></></ProtectedRoute>} />
          <Route path="/historical-pathway" element={<ProtectedRoute><><Header /><HistoricalPathway /></></ProtectedRoute>} />
    <Route path="/client-history" element={<ProtectedRoute><><Header /><ClientHistory /></></ProtectedRoute>} />
        </Routes>
        </URLLockGuard>
      </div>

      {/* Footer - Hidden on Login page */}
      {!isLoginPage && <Footer />}

      {/* Daily Reminder Popup */}
      <ReminderPopup />

    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
